import { Link } from "react-router-dom";

export default function QuickActionCard({ to, icon: Icon, label, badge }) {
  return (
    <Link
      to={to}
      data-testid={`quick-action-${label.toLowerCase()}`}
      className="group bg-card rounded-xl p-3 border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300 flex flex-col items-center gap-1.5 text-center"
    >
      <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
        <Icon className="w-5 h-5" />
      </div>
      <p className="text-xs font-medium text-foreground">{label}</p>
      {badge && (
        <span className="px-1.5 py-0.5 rounded-full bg-secondary text-secondary-foreground text-[10px] font-bold">
          {badge}
        </span>
      )}
    </Link>
  );
}
